import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Toolbar } from "primereact/toolbar";
import { useFormik } from "formik";
import Consts from "../../utilities/Consts";
import CommonHelper from "../../utilities/CommonHelper";
import StringHelper from "../../utilities/StringHelper";
import { LkDropDown } from "../../components/LkDropDown";

export const BayiSelect = (props) => {
  const { ddBayi = [], bayi_id, onCloseSidebar } = props;
  const cLabels = Consts.localizedStrings;

  const formik = useFormik({
    initialValues: {
      bayi_id: bayi_id,
    },
    validateOnChange: false,
    validateOnBlur: false,
    validate: (data) => {
      let errors = {};

      if (StringHelper.isEmpty(data.bayi_id)) {
        errors.bayi_id = cLabels.requiredField;
      }
      if (Object.keys(errors).length !== 0) {
        CommonHelper.showWarnMessage(cLabels.lutfen_girdiginiz_bigileri_kontrol_ediniz);
      }

      return errors;
    },
    onSubmit: (data) => {
      onCloseSidebar(data.bayi_id);
    },
  });

  useEffect(() => {
    formik.setFieldValue("bayi_id", bayi_id);
  }, [bayi_id]);

  const template = (options) => {
    const className = `${options.className} p-jc-start`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className={className}>
        <span className={titleClassName}>{cLabels.bayi}</span>
        <Button icon="pi pi-times" className="p-button-rounded p-button-danger" onClick={() => onCloseSidebar()} />
      </div>
    );
  };

  return (
    <Panel toggleable headerTemplate={template}>
      <form id="bayi-select-form" onSubmit={formik.handleSubmit}>
        <div className="grid p-fluid p-formgrid">
          <div className="p-field col-12">
            <label>{cLabels.bayi}</label>
            <LkDropDown options={ddBayi} id="bayi_id" formik={formik} isField={true} />
          </div>
        </div>
      </form>
      <div className="col-12 clear">
        <Toolbar right={<Button label={cLabels.save} type="submit" form="bayi-select-form" icon="pi pi-check" className="p-button-success p-mr-2" />} />
      </div>
    </Panel>
  );
};